/**
 * `date` defaults to now, which is what the write paths (stamping
 * `timezoneAbbreviation` at creation) want. Display paths must pass the event's
 * own instant — the abbreviation is DST-dependent, so a December event in New
 * York reads EST, not the EDT you'd get by asking in July.
 */
export const getTimezoneAbbreviation = (timezone: string, date: Date = new Date()): string => {
  const formatter = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone && timezone.trim() ? timezone : undefined,
    timeZoneName: 'short',
  });
  const parts = formatter.formatToParts(date);
  const abbreviationPart = parts.find((part) => part.type === 'timeZoneName');
  return abbreviationPart ? abbreviationPart.value : '';
};
